export interface IAppReportTaskTypeEventReference {
    name: string;
    reportId: string;
    chartId: string;
    reportFilter: any;
    generalFilter: any;
}

export class AppReportTaskTypeEventReference implements IAppReportTaskTypeEventReference {
    name: string;
    reportId: string;
    chartId: string;
    reportFilter: any;
    generalFilter: any;

    constructor();
    constructor(obj: IAppReportTaskTypeEventReference);
    constructor(obj?: any) {
        this.name = obj && obj.name || "";
        this.reportId = obj && obj.reportId || "";
        this.chartId = obj && obj.chartId || "";
        this.reportFilter = obj && obj.reportFilter || null;
        this.generalFilter = obj && obj.generalFilter || null;
    }
}